import {RouterModule, Routes} from "@angular/router";
import {BaseComponent} from "./pages/base.component";
import {NgModule} from "@angular/core";
import {ErrorNotFoundComponent} from "./pages/error-not-found/error-not-found.component";

const routes: Routes = [
  {
    path: '',
    component: BaseComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('../feedback/feedback.module').then(m => m.FeedbackModule)
      },
      {
        path: '**',
        component: ErrorNotFoundComponent
      },
      {
        path: '404',
        component: ErrorNotFoundComponent
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class BaseRoutingModule {
}
